var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--twemoji",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#77B255",
    d: "M35 36v-5a6 6 0 0 0-6-6H13a6 6 0 0 0-6 6v5h28z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3D2A2",
    d: "M16.64 25.106c0 .894 2.36 1.993 4.36 1.993s4.359-1.099 4.359-1.992V21.29h-8.72v3.816z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E2C196",
    d: "M16.632 22.973c1.216 1.374 2.724 1.746 4.364 1.746c1.639 0 3.146-.373 4.363-1.746v-3.491h-8.728v3.491z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3D2A2",
    d: "M14.444 12.936c0 1.448-.734 2.622-1.639 2.622s-1.639-1.174-1.639-2.622s.734-2.623 1.639-2.623c.905-.001 1.639 1.174 1.639 2.623m16.389 0c0 1.448-.733 2.622-1.639 2.622c-.905 0-1.639-1.174-1.639-2.622s.733-2.623 1.639-2.623c.906-.001 1.639 1.174 1.639 2.623"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3D2A2",
    d: "M12.477 13.96c0-5.589 3.816-10.121 8.523-10.121s8.522 4.532 8.522 10.121S25.707 24.081 21 24.081c-4.706-.001-8.523-4.532-8.523-10.121"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1694F",
    d: "M21 20.802c-2.754 0-3.6-.705-3.741-.848a.655.655 0 0 1 .902-.95c.052.037.721.487 2.839.487c2.2 0 2.836-.485 2.842-.49a.638.638 0 0 1 .913.015a.669.669 0 0 1-.014.938c-.141.143-.987.848-3.741.848"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE51E",
    d: "M21 0c5.648 0 9.178 4.648 9.178 8.121c0 3.473-.706 4.863-1.412 3.473l-1.412-2.778s-4.235 0-5.647-1.39c0 0 2.118 4.168-2.118 0c0 0 .706 2.779-3.53-.694c0 0-2.118 1.389-2.824 4.862c-.196.964-1.412 0-1.412-3.473C11.822 4.648 14.646 0 21 0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#662113",
    d: "M17 14c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1s1 .45 1 1v1c0 .55-.45 1-1 1m8 0c-.55 0-1-.45-1-1v-1c0-.55.45-1 1-1s1 .45 1 1v1c0 .55-.45 1-1 1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#C1694F",
    d: "M21.75 16.75h-1.5c-.413 0-.75-.337-.75-.75s.337-.75.75-.75h1.5c.413 0 .75.337.75.75s-.337.75-.75.75"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#E1E8ED",
    d: "M33 35a1 1 0 0 1-1 1H22a1 1 0 1 1 0-2h10a1 1 0 0 1 1 1z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#E1E8ED",
    d: "M20.24 22H3.759c-1.524 0-3.478.771-2.478 3.531l3.072 8.475C4.354 34.006 4.75 36 7 36h20l-4-11.24c-.438-1.322-1.235-2.76-2.76-2.76z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#99AAB5",
    d: "M19.24 22H2.759c-1.524 0-3.478.771-2.478 3.531l3.072 8.475C3.354 34.006 3.75 36 6 36h20l-4-11.24c-.438-1.322-1.235-2.76-2.76-2.76z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#E1E8ED",
    d: "M14.019 29.283c.524 1.572.099 3.13-.949 3.479c-1.048.35-2.322-.641-2.846-2.213s-.099-3.13.949-3.479c1.048-.349 2.323.641 2.846 2.213zM19 24.75H3a.75.75 0 0 1 0-1.5h16a.75.75 0 0 1 0 1.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.43370030407e36f9d1767ff93b2c7e8c.svg";
export { ForwardRef as ReactComponent };